const translations = {
    'biome.coast': 'wybrzeże',
    'biome.forest': 'las',
    'biome.hills': 'wzgórza',
    'biome.mountains': 'góry',
    'biome.plains': 'równiny',
    'biome.water': 'woda',
    'biome.wetlands': 'mokradła',
};

export default translations;
